import { clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * `text-ds-*` are font-size tokens. Without this, tailwind-merge treats unknown
 * `text-*` classes as colors and drops `text-primary-foreground` / badge colors.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: ["ds-h1", "ds-h2", "ds-h3", "ds-body", "ds-caption"],
        },
      ],
    },
  },
})

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}